import { Status } from './status';

export class ListValueForAutocomplete {
  value: string;
  label: string;
  status: Status;

  constructor(value: string, label: string) {
    this.value = value;
    this.label = label;
  }
}
